import 'bootstrap'
import '@hotwired/turbo'
import '../controllers'
import '../src/common'
import '../src/turbo_redirect_custom' // turbo frame 内でページ全体をリダイレクトさせる処理

Turbo.start()

// Turboを無効化して必要なelementにdata-turbo="true"を追加する
Turbo.session.drive = false
